export const excludeMenuList = ['online-course', 'notify', 'video'];